import React from 'react';
import DrawerAddBroker from './body/add';
import DrawerProfile from './body/profile';
import { JSONSchema, TError, TStandardSectionStep } from 'models';
import { AxiosError } from 'axios';
import { DrawerStyled } from 'app/Components/common/Drawer/styles';
import { TBroker } from '../../common';

interface IProps {
  type: string,
  scheme?: JSONSchema,
  errors?: TError[],
  step: TStandardSectionStep,
  selectedUser: TBroker | null,
  brokerId?: string,
  handleDrawerClose: () => void,
  updateStep: (step: string) => void,
  handlePatchUser: (selectedUser: TBroker, onError?: (errors: AxiosError) => void) => void,
  handleDeleteUser: () => void,
  updateSelectedUser: (broker: TBroker) => void,
  handlePostUser: (broker: TBroker, onError: (error: AxiosError) => void) => void,
}

const Drawer = ({
  type,
  selectedUser,
  brokerId,
  handleDrawerClose,
  updateStep,
  step,
  handlePatchUser,
  handleDeleteUser,
  updateSelectedUser,
  handlePostUser,
}: IProps) => (
  <DrawerStyled show={!!selectedUser || !!brokerId || type === 'add'} dir="right" $step={step}>
    {DrawerBody({
      type,
      selectedUser,
      brokerId,
      handleDrawerClose,
      updateStep,
      step,
      handlePatchUser,
      handleDeleteUser,
      updateSelectedUser,
      handlePostUser
    })}
  </DrawerStyled>
);

const DrawerBody = ({
  type,
  selectedUser,
  brokerId,
  handleDrawerClose,
  updateStep,
  step,
  handlePatchUser,
  handleDeleteUser,
  updateSelectedUser,
  handlePostUser
}: IProps) => {

  switch (type) {
    case 'add':
      return (
        <DrawerAddBroker
          handleDrawerClose={handleDrawerClose}
          handlePostUser={handlePostUser}
        />
      );
    case 'profile':
    default:
      return (
        <DrawerProfile
          selectedUser={selectedUser}
          brokerId={brokerId}
          handleDrawerClose={handleDrawerClose}
          updateStep={updateStep}
          step={step}
          handlePatchUser={handlePatchUser}
          handleDeleteUser={handleDeleteUser}
          updateSelectedUser={updateSelectedUser}
        />
      );
  }
};

export default Drawer;
